var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      style: _vm.modalStyle,
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        forceRender: true,
        fullscreen: "",
        switchFullscreen: "",
        wrapClassName: "ant-modal-cust-warp",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "top-toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-left" },
          [
            _c(
              "a-button",
              {
                key: "templateSetting",
                attrs: { icon: "setting" },
                on: { click: _vm.handleTemplateSetting },
              },
              [_vm._v("模板设置")]
            ),
            _c(
              "a-button",
              {
                key: "printPreview",
                attrs: { type: "primary", icon: "printer" },
                on: { click: _vm.handlePrintPreview },
              },
              [_vm._v("打印预览")]
            ),
            _c(
              "a-checkbox",
              {
                on: { change: _vm.onAutoPrintChange },
                model: {
                  value: _vm.autoPrint,
                  callback: function ($$v) {
                    _vm.autoPrint = $$v
                  },
                  expression: "autoPrint",
                },
              },
              [_vm._v("自动")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content-toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-left" },
          [
            _c("span", { staticClass: "toolbar-label" }, [_vm._v("模板:")]),
            _c(
              "a-select",
              {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "选择模板" },
                on: { change: _vm.onTemplateChange },
                model: {
                  value: _vm.selectedTemplateId,
                  callback: function ($$v) {
                    _vm.selectedTemplateId = $$v
                  },
                  expression: "selectedTemplateId",
                },
              },
              _vm._l(_vm.templateList, function (tpl) {
                return _c(
                  "a-select-option",
                  { key: tpl.id, attrs: { value: tpl.id } },
                  [
                    _vm._v(
                      "\n          " + _vm._s(tpl.templateName) + "\n        "
                    ),
                  ]
                )
              }),
              1
            ),
            _c("span", { staticClass: "toolbar-label" }, [_vm._v("缩放:")]),
            _c(
              "a-select",
              {
                staticStyle: { width: "80px" },
                attrs: { placeholder: "缩放" },
                on: { change: _vm.onZoomChange },
                model: {
                  value: _vm.zoomLevel,
                  callback: function ($$v) {
                    _vm.zoomLevel = $$v
                  },
                  expression: "zoomLevel",
                },
              },
              [
                _c("a-select-option", { attrs: { value: 50 } }, [
                  _vm._v("50%"),
                ]),
                _c("a-select-option", { attrs: { value: 75 } }, [
                  _vm._v("75%"),
                ]),
                _c("a-select-option", { attrs: { value: 100 } }, [
                  _vm._v("100%"),
                ]),
                _c("a-select-option", { attrs: { value: 125 } }, [
                  _vm._v("125%"),
                ]),
                _c("a-select-option", { attrs: { value: 150 } }, [
                  _vm._v("150%"),
                ]),
              ],
              1
            ),
            _c(
              "a-button",
              { attrs: { icon: "reload" }, on: { click: _vm.handleRefresh } },
              [_vm._v("刷新")]
            ),
          ],
          1
        ),
      ]),
      _c("template", { slot: "footer" }, [
        _c("div", { staticClass: "footer-bar" }, [
          _c(
            "div",
            { staticClass: "footer-right" },
            [
              _c("a-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading, tip: "正在加载模板..." } },
        [
          _c("div", { staticClass: "hiprint-container" }, [
            !_vm.templateJson && !_vm.loading
              ? _c(
                  "div",
                  { staticClass: "no-template" },
                  [
                    _c(
                      "a-empty",
                      { attrs: { description: "暂无打印模板" } },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleTemplateSetting },
                          },
                          [_vm._v("去设置模板")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c("div", { staticClass: "preview-wrapper" }, [
                  _c("div", {
                    ref: "printContent",
                    staticClass: "print-content",
                    style: {
                      transform: `scale(${_vm.zoomLevel / 100})`,
                      transformOrigin: "top center",
                    },
                  }),
                ]),
          ]),
        ]
      ),
      _c(
        "a-modal",
        {
          staticStyle: { top: "10px" },
          attrs: {
            visible: _vm.designerVisible,
            title: "模板设计",
            width: "95%",
            footer: null,
            maskClosable: false,
          },
          on: { cancel: _vm.onDesignerClose },
        },
        [
          _c(
            "div",
            { staticClass: "designer-wrapper" },
            [
              _vm.designerVisible
                ? _c("TemplateDesignerV2", {
                    ref: "templateDesigner",
                    attrs: {
                      billType: _vm.billTypeCode,
                      billTypeName: _vm.billType,
                      billNo: _vm.currentBillNo,
                      templateId: _vm.selectedTemplateId,
                      billData: _vm.printData,
                      embedded: true,
                    },
                    on: {
                      close: _vm.onDesignerClose,
                      saved: _vm.onDesignerSaved,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.printDialogVisible,
            title: "打印预览",
            width: "90%",
            footer: null,
            wrapClassName: "print-dialog-modal",
          },
          on: {
            cancel: function ($event) {
              _vm.printDialogVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "print-dialog-container" }, [
            _c("div", { staticClass: "print-settings" }, [
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c("h4", [_vm._v("打印机")]),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "选择打印机" },
                      model: {
                        value: _vm.selectedPrinter,
                        callback: function ($$v) {
                          _vm.selectedPrinter = $$v
                        },
                        expression: "selectedPrinter",
                      },
                    },
                    _vm._l(_vm.printerList, function (printer) {
                      return _c("a-select-option", { key: printer }, [
                        _vm._v(_vm._s(printer)),
                      ])
                    }),
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { size: "small", icon: "reload" },
                      on: { click: _vm.refreshPrinters },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c("h4", [_vm._v("份数")]),
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 1, max: 99 },
                    model: {
                      value: _vm.printCopies,
                      callback: function ($$v) {
                        _vm.printCopies = $$v
                      },
                      expression: "printCopies",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c("h4", [_vm._v("方向")]),
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.printOrientation,
                        callback: function ($$v) {
                          _vm.printOrientation = $$v
                        },
                        expression: "printOrientation",
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: "portrait" } }, [
                        _vm._v("纵向"),
                      ]),
                      _c("a-radio", { attrs: { value: "landscape" } }, [
                        _vm._v("横向"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c("h4", [_vm._v("纸张")]),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { defaultValue: "A4" },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "A4" } }, [
                        _vm._v("A4"),
                      ]),
                      _c("a-select-option", { attrs: { value: "A5" } }, [
                        _vm._v("A5"),
                      ]),
                      _c("a-select-option", { attrs: { value: "B5" } }, [
                        _vm._v("B5"),
                      ]),
                      _c("a-select-option", { attrs: { value: "Letter" } }, [
                        _vm._v("Letter"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "print-actions" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "printer", block: "" },
                      on: { click: _vm.doPrint },
                    },
                    [_vm._v("打印")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "print-preview-area" }, [
              _c("div", { staticClass: "preview-toolbar" }, [
                _c("span", [_vm._v("共 1 页")]),
              ]),
              _c(
                "div",
                { ref: "printPreviewContent", staticClass: "preview-content" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "preview-paper",
                      style: {
                        transform: `scale(${_vm.zoomLevel / 100})`,
                        transformOrigin: "top center",
                      },
                    },
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.previewHtml) },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }